import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const bayerische = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Die Bayerische Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "Finden Sie die beste Werkstatt in Ihrer Nähe.",
        subtitle: "Das Service-Portal der Bayerischen",
      },
      layout: {
        backText: "Zurück zu diebayerische.de",
        navbar: {
          partnerLogo: {
            alt: "Die Bayerische",
          },
        },
      },
      reportDamage: {
        title: "Wollen Sie einen Schaden melden?",
        yesDescription: "Ich möchte einen Schaden melden",
        noDescription: "Ich suche nach einer Werkstatt",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/bayerische",
    },
  },
};
